import React from 'react';
import { connect } from 'react-redux';
import { bool, func, object, string } from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import Logo from '../Logo/Logo';
import Notifications from '../Notifications/Notifications';
import SearchBar from '../SearchBar/SearchBar';
import AccountNav from '../AccountNav/AccountNav';
import Likes from '../Likes/Likes';
import Rewards from '../Rewards/Rewards';
import CartNav from '../CartNav/CartNav';

import styles from './TopBar-style.scss';

const TopBar = props => {
    const {
        disableStickyNav,
        hasRootPendingRefetch,
        hasUserId,
        hasUser,
        isClient,
        user,
        userId,
        viewer,
        onMouseOver,
        hasError,
        isEmailOnly,
    } = props;
    const { isNotificationsEnabled, isFavoritesEnabled, isCartEnabled } = viewer;

    const barClasses = classnames({
        [styles.bar]: true,
        [styles.disableSticky]: disableStickyNav,
    });

    if (hasError) {
        return (
            <div className={barClasses}>
                <div className={`${styles.barContent} js-nav-utils-wrap`}>
                    <div className={styles.leftContainer}>
                        <Logo />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={barClasses} onMouseOver={onMouseOver}>
            <div className={`${styles.barContent} js-nav-utils-wrap`}>
                <div className={styles.leftContainer}>
                    <Logo />
                    <SearchBar
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isClient={isClient}
                        viewer={viewer}
                    />
                </div>
                <div className={styles.rightContainer}>
                    <AccountNav
                        isClient={isClient}
                        hasUser={hasUser}
                        hasUserId={hasUserId}
                        viewer={viewer}
                        user={user}
                    />

                    {isNotificationsEnabled && !isEmailOnly && (
                        <Notifications
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            isClient={isClient}
                            userId={userId}
                            viewer={viewer}
                            initialViewer={viewer}
                            user={user}
                        />
                    )}

                    {isFavoritesEnabled && (
                        <Likes
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            fetchNewEvents={hasUserId && isClient && !hasRootPendingRefetch}
                            isClient={isClient}
                            userId={userId}
                            viewer={viewer}
                        />
                    )}

                    {!isEmailOnly && (
                        <Rewards
                            isClient={isClient}
                            hasUser={hasUser}
                            hasUserId={hasUserId}
                            user={user}
                        />
                    )}
                    {isCartEnabled && (
                        <CartNav
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            isClient={isClient}
                            user={user}
                            userId={userId}
                            viewer={viewer}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

TopBar.propTypes = {
    hasError: bool,
    disableStickyNav: bool,
    hasRootPendingRefetch: bool,
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    openDrawer: func,
    user: object,
    userId: string,
    viewer: object,
    onMouseOver: func,
    isEmailOnly: bool,
};

const mapStateToProps = ({ header }) => ({
    isEmailOnly: header.isEmailOnly,
});

export default createFragmentContainer(connect(mapStateToProps)(TopBar), {
    viewer: graphql`
        fragment TopBar_viewer on Viewer {
            isNotificationsEnabled: isEnabledByLocale(featureName: "NOTIFICATIONS")
            isFavoritesEnabled: isEnabledByLocale(featureName: "FAVORITES")
            isCartEnabled: isEnabledByLocale(featureName: "CART")
            ...AccountNav_viewer
            ...CartNav_viewer
            ...Likes_viewer
            ...Notifications_viewer
            ...Notifications_initialViewer
            ...SearchBar_viewer
        }
    `,
    user: graphql`
        fragment TopBar_user on User {
            ...AccountNav_user
            ...Rewards_user
            ...CartNav_user
            ...Notifications_user
        }
    `,
});
